import { render } from "./LotsUnfulfilledPurchasesPage.vue?vue&type=template&id=170590af&scoped=true"
import script from "./LotsUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"
export * from "./LotsUnfulfilledPurchasesPage.vue?vue&type=script&lang=js"

import "./LotsUnfulfilledPurchasesPage.vue?vue&type=style&index=0&id=170590af&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170590af"]])

export default __exports__